import Common from '../common.js';

export default {
    login: function (login, password, successCallback, errorCallback) {
        var loginModel = {
            "loginType": 'email',
            "login": login,
            "password": password
        };
        var result = false;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/login',
            type: 'POST',
            data: $.toJSON(loginModel),
            dataType: "json",
            async: true,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            xhrFields: {
                withCredentials: true
            },
            success: function (data, textStatus) {
                result = true;
                if (successCallback != null) {
                    successCallback();
                }
            },
            error: function (jqXHR, data, textStatus) {
                result = false;
                if (errorCallback != null) {
                    errorCallback(data);
                }
            }
        });

        return result;
    },

    logged: function (successCallback, errorCallback) {
        var result = false;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/logged',
            type: 'POST',
            dataType: "json",
            async: false,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                result = true;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                result = false;
                try {
                    if (errorCallback != null) {
                        var obj = jQuery.parseJSON(jqXHR.responseText);
                        errorCallback(obj.message);
                    }
                }
                catch (e) {
                }

            }
        });

        return result;
    },
    locale: function (successCallback, errorCallback) {
        var result = false;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/locale',
            type: 'GET',
            dataType: "json",
            async: false,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                result = true;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                result = false;

                try {
                    if (errorCallback != null) {
                        var obj = jQuery.parseJSON(jqXHR.responseText);
                        errorCallback(obj.message);
                    }
                }
                catch (e) {
                }

            }
        });

        return result;
    },
    logout: function (onComplete) {
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/logout',
            type: 'POST',
            dataType: "json",
            xhrFields: {withCredentials: true},
            async: true,
            success: function (data, textStatus) {
                if (onComplete != null) {
                    onComplete();
                }
            },
            error: function (data, textStatus) {
            }
        });
    },
    register: function (phone, password, surname, name, recaptcha, successCallback, errorCallback) {

        var result = null;
        var registrationModel = {
            "phone": phone,
            "password": password,
            "fields": {
                "surname": surname,
                "name": name,
                "recaptcha": recaptcha
            }
        };
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/register',
            type: 'POST',
            data: $.toJSON(registrationModel),
            dataType: "json",
            contentType: 'application/json', xhrFields: {withCredentials: true},
            async: false,
            success: function (data, textStatus) {
                result = data;
                successCallback();
            },
            error: function (data, textStatus) {
                console.log('catched!');

                try {
                    var obj = jQuery.parseJSON(data.responseText);
                    errorCallback(obj.message);
                }
                catch (e) {
                    Common.showToast('error', 'Ошибка', 'Пожалуйста, используйте другой номер телефона');
                }
            }

        });

        return result;
    },
    sendRepairCode: function (login, async, successCallback, errorCallback) {
        var repairModel = {
            "loginType": login.indexOf("@") > -1 ? 'email' : 'phone',
            "login": login
        };
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/send-repair-code',
            type: 'POST',
            data: $.toJSON(repairModel),
            dataType: "json",
            contentType: 'application/json',
            xhrFields: {withCredentials: true},
            async: async,
            success: function (data, textStatus) {
                successCallback(data);
            },
            error: function (jqXHR, data, textStatus) {
                if (errorCallback != null) {
                    errorCallback([jqXHR, data, textStatus]);
                }
            }

        });
        return false;
    },
    changePassword: function (loginType, login, code, newPassword, async, successCallback, errorCallback) {
        var model = {
            "loginType": loginType,
            "login": login,
            "code": code,
            "newPassword": newPassword
        };
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/change-password',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            contentType: 'application/json',
            xhrFields: {withCredentials: true},
            async: async,
            success: function (data, textStatus) {
                if (successCallback != null) {
                    successCallback();
                }
            },
            error: function (jqXHR, data, textStatus) {
                if (errorCallback != null) {
                    errorCallback([jqXHR, data, textStatus]);
                }
                // var obj = jQuery.parseJSON(jqXHR.responseText);
                // Common.showToast('error', 'Ошибка', );
            }
        });
        return false;
    },
    addNick: function (nick, successCallback, errorCallback) {
        var model = {
            "value": nick
        };
        $.ajax({
            url: Application.getBasePath() + '/api/cabinet/add-nick',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            contentType: 'application/json', xhrFields: {withCredentials: true},
            async: true,
            success: function (data, textStatus) {
                successCallback();
            },
            error: function (data, textStatus) {
                if (errorCallback != null) {
                    errorCallback();
                }
            }

        });
        return false;
    },
    addEmail: function (email, successCallback, errorCallback) {
        var model = {
            "value": email
        };
        $.ajax({
            url: Application.getBasePath() + '/api/cabinet/add-email',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            contentType: 'application/json',
            xhrFields: {withCredentials: true},
            async: true,
            success: function (data, textStatus) {
                successCallback(data);
            },
            error: function (data, textStatus) {
                errorCallback(data);
            }

        });
        return false;
    },
    changeLocale: function (locale, async, successCallback, errorCallback) {
        var model = {
            "value": locale
        };
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/change-locale',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            contentType: 'application/json', xhrFields: {withCredentials: true},
            async: async,
            success: function (data, textStatus) {
                successCallback();
            },
            error: function (data, textStatus) {
                console.log('catched!');

                try {
                    var obj = jQuery.parseJSON(data.responseText);
                    errorCallback(obj.message);
                }
                catch (e) {
                    Common.showMessage('Internal Server Error');
                }
            }

        });
        return false;
    },
    saveSetting: function (key, value, async, successCallback, errorCallback) {
        var model = {
            "value": value
        };
        $.ajax({
            url: Application.getBasePath() + '/platform/api/setting/' + key + '/save',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                if (successCallback != null) {
                    successCallback();
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });
    },
    getSetting: function (key, async, successCallback, errorCallback) {
        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/setting/' + key,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });
        return d;
    },
    verifyEmail: function (id, code, async, successCallback, errorCallback) {
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/verify-email?id=' + id + '&code=' + code,
            type: 'POST',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                if (successCallback != null) {
                    successCallback();
                }
            },
            error: function (jqXHR, data, textStatus) {
                if (errorCallback != null) {
                    errorCallback();
                }
            }
        });
    },

    verifyPhone: function (id, code, async, successCallback, errorCallback) {
        $.ajax({
            url: Application.getBasePath() + '/platform/api/user/verify-phone?id=' + id + '&code=' + code,
            type: 'POST',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                if (successCallback != null) {
                    successCallback();
                }
            },
            error: function (jqXHR, data, textStatus) {
                if (errorCallback != null) {
                    errorCallback();
                }
            }
        });
    },

    getUserPoints: function (async, successCallback, errorCallback) {
        var result;
        $.ajax({
            url: Application.getBasePath() + '/api/profile/points',
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json',
            success: function (data, textStatus) {
                result = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');
                try {
                    if (errorCallback != null) {
                        var obj = jQuery.parseJSON(jqXHR.responseText);
                        errorCallback(obj.message);
                    }
                }
                catch (e) {
                }
            }
        });
        return result;
    },

    saveUserProfile: function (profile, successCallback, errorCallback) {
        var result = null;
        $.ajax({
            url: Application.getBasePath() + '/api/profile/save',
            type: 'POST',
            data: $.toJSON(profile),
            dataType: "json",
            async: false,
            contentType: 'application/json',
            success: function (data, textStatus) {
                result = data;
                Common.showToast('success', 'Успех', 'Изменения успешно сохранены');
                if (successCallback != null) {
                    successCallback();
                }
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');
                var obj = jQuery.parseJSON(jqXHR.responseText);
                Common.showToast('error', 'Ошибка', obj.message);
                if (errorCallback != null) {
                    errorCallback(data);
                }
            }
        });
        return result;
    },

    authProviders: function () {
        var result = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/oauth/providers',
            type: 'GET',
            dataType: "json",
            async: false,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                result = data;
            },
            error: function (jqXHR, data, textStatus) {
            }
        });

        return result;
    },

};


// WEBPACK FOOTER //
// ./src/api/user.js